import { List, Theme } from '@mui/material';
import { NavItem, NavItemProps } from './NavItem';
import { NavItemWithSubRoutes, NavItemWithSubRoutesProps } from './NavItemWithSubRoutes';
import { NavRoute, NavWithSubRoutes } from './types';
import { SystemStyleObject } from '@mui/system';
import { ReactNode } from 'react';

export interface NavigationProps {
  navRoutes: (NavRoute | NavWithSubRoutes)[];
  expandedView: boolean;
  overridingListItemStyles?: SystemStyleObject<Theme>;
  expandView: () => void;
  CustomNavItemWithSubRoutes?: (props: NavItemWithSubRoutesProps) => JSX.Element;
  CustomNavItem?: (props: NavItemProps) => ReactNode;
}

export function Navigation({
  navRoutes,
  expandedView,
  overridingListItemStyles,
  expandView,
  CustomNavItemWithSubRoutes = NavItemWithSubRoutes,
  CustomNavItem = NavItem,
}: NavigationProps) {
  return (
    <List sx={{ padding: 3 }} component="nav">
      {navRoutes.map((navRoute) => {
        if ('subRoutes' in navRoute) {
          const { title, Icon, to, isActive, subRoutes, initialOpen } = navRoute;

          return (
            <CustomNavItemWithSubRoutes
              title={title}
              Icon={Icon}
              to={to}
              isActive={isActive}
              subRoutes={subRoutes}
              expandView={expandView}
              expandedView={expandedView}
              key={title}
              initialOpen={initialOpen}
            />
          );
        }

        const { title, Icon, to, isActive, external, href } = navRoute;

        return (
          <CustomNavItem
            key={to}
            title={title}
            Icon={Icon}
            to={to}
            external={external}
            href={href}
            isActive={isActive}
            expandedView={expandedView}
            overridingListItemStyles={overridingListItemStyles}
          />
        );
      })}
    </List>
  );
}
